export const routeEndpoints = {
  landing: "/",
  orders: "/orders",
  order: "/order",
  shippingStatus: "/shipping-status",
  authorize: "/authorize",
  login: "/login",
  signup: "/signup",
  verifyEmail: "/verify-email",
  forgotPassword: "/forgot-password",
  verifyResetCode: "/verify-reset-code",
  resetPassword: "/reset-password",
  settings: "/settings",
};
